module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "background-light"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "/static/img/icgc-logo.png",
      "alt": "Institut Cartogràfic i Geològic de Catalunya"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isViewerMode),
      expression: "!isViewerMode"
    }],
    staticClass: "back-to-top"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cookies-footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-fix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "seamless-button"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_upward")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce4a151a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/footer/footer.vue
// module id = 321
// module chunks = 0